// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "mobileStep__header-1HFoO";
var _4 = "price__total-1j6RC";
var _5 = "price__row-1GcZq";
export { _1 as "__esModule", _2 as "mobile", _3 as "mobileStep__header", _4 as "price__total", _5 as "price__row" }
export default { "__esModule": _1, "mobile": _2, "mobileStep__header": _3, "price__total": _4, "price__row": _5 }
